// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import openPipsSummary from './open-pips-summary';
import pipProducts from './pip-products';
import pipProductsFiltered from './pip-products-filtered';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facets,
    hasSearchResults,
    openPipsSummary,
    pipProducts,
    pipProductsFiltered,
    reportsAccordion,
    searchByDropDown,
    searchFilters,
    searchQueryString
});



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/index.js